import React from "react";
import { HashLink } from "react-router-hash-link";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const Prosthodontics = () => {
  const { t, i18n } = useTranslation();

  return (
    <div
      className="container py-5 mt-5"
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
    >
      <Helmet>
        <link
          rel="canonical"
          href="https://saleemsmile.com/articles/dental-crowns"
        />

        <title>{t("Prosthodontics.seo.title")}</title>
        <meta
          name="description"
          content={t("Prosthodontics.seo.description")}
        />
        <meta name="keywords" content={t("Prosthodontics.seo.keywords")} />

        <meta property="og:title" content={t("Prosthodontics.seo.ogTitle")} />
        <meta
          property="og:description"
          content={t("Prosthodontics.seo.ogDescription")}
        />
        <meta
          property="og:image"
          content="https://via.placeholder.com/800x450.png?text=Prosthodontics+Dental+Crowns+Bridges"
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:locale"
          content={i18n.language === "ar" ? "ar_AR" : "en_US"}
        />
      </Helmet>

      <h1 className="mb-4 text-center" style={{ color: "#00b3ff" }}>
        {t("Prosthodontics.page.title")}
      </h1>
      <h5 className="text-center mb-5">{t("Prosthodontics.page.subtitle")}</h5>
      <p className="text-center text-muted">
        {t("Prosthodontics.page.center")}
      </p>

      <h2 className="mt-4">{t("Prosthodontics.page.whatTitle")}</h2>
      <p>{t("Prosthodontics.page.whatP1")}</p>
      <p>{t("Prosthodontics.page.whatP2")}</p>
      <p>{t("Prosthodontics.page.whatP3")}</p>

      <h2 className="mt-4">{t("Prosthodontics.page.benefitsTitle")}</h2>
      <ul>
        {t("Prosthodontics.page.benefitsList", { returnObjects: true }).map(
          (item, idx) => (
            <li key={idx}>{item}</li>
          )
        )}
      </ul>

      <h2 className="mt-4">{t("Prosthodontics.page.typesTitle")}</h2>
      <p>{t("Prosthodontics.page.typesIntro")}</p>

      <h3 className="mt-3">{t("Prosthodontics.page.crownsTitle")}</h3>
      <p>{t("Prosthodontics.page.crownsP")}</p>
      <ul>
        {t("Prosthodontics.page.crownsList1", { returnObjects: true }).map(
          (item, idx) => (
            <li key={idx}>{item}</li>
          )
        )}
      </ul>
      <p>{t("Prosthodontics.page.crownsTypes")}</p>
      <ul>
        {t("Prosthodontics.page.crownsList2", { returnObjects: true }).map(
          (item, idx) => (
            <li key={idx}>{item}</li>
          )
        )}
      </ul>

      <h3 className="mt-3">{t("Prosthodontics.page.bridgesTitle")}</h3>
      <p>{t("Prosthodontics.page.bridgesP")}</p>
      <ul>
        {t("Prosthodontics.page.bridgesList", { returnObjects: true }).map(
          (item, idx) => (
            <li key={idx}>{item}</li>
          )
        )}
      </ul>

      <h3 className="mt-3">{t("Prosthodontics.page.denturesTitle")}</h3>
      <p>{t("Prosthodontics.page.denturesP")}</p>
      <ul>
        {t("Prosthodontics.page.denturesList", { returnObjects: true }).map(
          (item, idx) => (
            <li key={idx}>{item}</li>
          )
        )}
      </ul>

      <h2 className="mt-4">{t("Prosthodontics.page.materialsTitle")}</h2>
      <ul>
        {t("Prosthodontics.page.materialsList", { returnObjects: true }).map(
          (item, idx) => (
            <li key={idx}>{item}</li>
          )
        )}
      </ul>

      <h2 className="mt-4">{t("Prosthodontics.page.durationTitle")}</h2>
      <p>{t("Prosthodontics.page.durationP")}</p>

      <h2 className="mt-4">{t("Prosthodontics.page.careTitle")}</h2>
      <ul>
        {t("Prosthodontics.page.careList", { returnObjects: true }).map(
          (item, idx) => (
            <li key={idx}>{item}</li>
          )
        )}
      </ul>

      <h2 className="mt-4">{t("Prosthodontics.page.whyTitle")}</h2>
      <ul>
        {t("Prosthodontics.page.whyList", { returnObjects: true }).map(
          (item, idx) => (
            <li key={idx}>{item}</li>
          )
        )}
      </ul>

      <h2 className="mt-4">{t("Prosthodontics.page.messageTitle")}</h2>
      <p>
        <em>{t("Prosthodontics.page.messageText")}</em>
      </p>

      <footer className="mt-4">
        <HashLink to="/#services" className="btn btn-outline-secondary">
          {t("Prosthodontics.page.back")}
        </HashLink>
      </footer>
    </div>
  );
};

export default Prosthodontics;
